import styled from 'styled-components'
import Color from 'color'

import { Text } from '@/ui'

export const TopBarWrapper = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  padding: 10px 16px;
`

export const MonthHeadline = styled(Text.H1)`
  &&& {
    margin-bottom: 0;
    text-transform: capitalize;
    font-size: 20px;
    margin: 0 16px;
  }
`

export const NumberOfDaysDropdown = styled.div`
  border-radius: 0 4px 4px 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  border-left: 1px solid transparent;
  height: 100%;

  .icon {
    transform: scale(0.5);
  }
`

export const ViewButton = styled.button<{ hasDropdown: boolean }>`
  height: 32px;
  border-radius: ${({ hasDropdown }) => (hasDropdown ? '4px 0 0 4px' : '4px')};
  border: none;
  padding: 0 14px;
  background: transparent;
  cursor: pointer;
  border-right: ${props =>
    props.hasDropdown ? '1px solid transparent' : 'none'};

  .icon {
    color: ${props => props.theme.secondaryFontColor};
  }

  &:focus {
    border: none;
  }

  &.active {
    background: ${props => props.theme.primaryColor};
    color: ${props => props.theme.secondaryFontColor};
    border-right: ${props =>
      props.hasDropdown ? `1px solid ${props.theme.primaryColor}` : 'none'};
  }
`

export const ButtonWrapper = styled.div<{ hasDropdown: boolean }>`
  display: flex;

  &:not(.active):hover {
    ${ViewButton}, ${NumberOfDaysDropdown} {
      background: #e6e8eb;
    }

    ${ViewButton} {
      border-right: ${props =>
        props.hasDropdown
          ? `1px solid ${Color('#e6e8eb').lighten(0.05).string()}`
          : 'none'};
    }

    ${NumberOfDaysDropdown} {
      border-left: 1px solid ${Color('#e6e8eb').darken(0.1).string()};
    }
  }

  &.active {
    ${NumberOfDaysDropdown} {
      background: ${props => props.theme.primaryColor};
      border-left: ${props => `1px solid ${props.theme.primaryColor}`};

      .icon {
        color: ${props => props.theme.secondaryFontColor};
      }
    }

    &:hover {
      ${ViewButton} {
        border-right: ${props =>
          props.hasDropdown
            ? `1px solid ${Color(props.theme.primaryColor)
                .lighten(0.15)
                .string()}`
            : 'none'};
      }

      ${NumberOfDaysDropdown} {
        border-left: ${({ theme }) =>
          `1px solid ${Color(theme.primaryColor).darken(0.2).string()}`};
      }
    }
  }
`

export const ViewsWrapper = styled.div`
  display: flex;
  gap: 4px;
  border-radius: 4px;
  padding: 4px;
  border: 1.14286px solid #e6e8eb;
  margin-right: 15px;
`

export const DayNumberOption = styled.div<{ active: boolean }>`
  display: flex;
  cursor: pointer;
  border-radius: 4px;
  padding: 3px 6px;
  justify-content: center;
  border: 1px solid ${props => (props.active ? '#ffffff4e' : 'transparent')};
  background: ${props => (props.active ? '#ffffff3b' : '#ffffff13')};

  &:hover {
    background: #ffffff3b;
  }

  &:not(:last-child) {
    margin-bottom: 4px;
  }
`
